<template lang="pug">
#app
	Nav
	router-view
	Footer
</template>

<script>
import Nav from '@/components/Nav.vue';
import Footer from '@/components/Footer.vue';
export default {
	components: {
		Footer,
		Nav,
	},
};
</script>

<style lang="stylus">
#app
	font-family: Avenir, Helvetica, Arial, sans-serif
	-webkit-font-smoothing: antialiased
	-moz-osx-font-smoothing: grayscale
	background-image: url('~@/assets/images/background.png')
	background-size: 100% auto
	text-align: center
	color: #2c3e50
	h1
		font-size: $fs-1
		font-weight: 600
	h2
		font-size: $fs-2
		font-weight: 600
		line-height: 1.5
	h3
		font-size: $fs-3
		font-weight: 500
	h4
		font-size: $fs-4
		font-weight: 400
	h5
		font-size: $fs-5
		font-weight: 400
	a
		text-decoration: none
.page
	min-height: 100vh
#page_content
	padding-bottom: 50px
	text-align: left
	color: #fff
	.article
		background-color: $color_dark
		border-radius: 15px
		overflow: hidden
		padding: 6rem 0
		line-height: 2
		text-align: left
		img
			width: 100%
		.note
			color: $color_light
			margin: 20px 0 60px 0
		.content
			text-align: left
			color: #fff
			line-height: 2
			margin-bottom: 30px
	@media screen and (max-width: $screen-sm-max)
		.article
			border-radius: 0
			padding: 2rem 20px
.list_badge
	display: flex
	flex-wrap: wrap
	margin-top: 1rem
	.badge
		display: inline-block
		padding: 0.5rem 1rem
		border: 1px solid white
		border-radius: 2rem
		margin: 0 0.5rem 0.5rem 0
.title_underline
	display: flex
	flex-direction: column
	align-items: center
	margin: 3rem 0 1rem
	.text
		color: white
		margin-bottom: -4px

.button_action
	position: relative
	display: inline-block
	background-color: $color_yellow
	border-radius: 10px
	.wrapper
		display: flex
		justify-content: center
		align-items: center
		.text
			font-size: $fs-3
			font-weight: 500
			line-height: 24px
			color: $color_dark
			padding: 14px 6rem
		img
			display: none
			position: absolute
			right: 1rem
			top: 50%
			transform: translate(-50%, -50%)
	&.icon
		border-radius: 2rem
		.wrapper
			img
				display: inline-block
@media screen and (max-width: $screen-sm-max)
	h1
		font-size: $fs-1-mb
</style>
